import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PaginationBar from './PaginationBar';
import { getArticles, updateFavourite, getFavourites } from '../../../Actions/Dashboard/articles';

class ArticleBlockObj extends React.Component {
  updateFavourite = () => {
    this.props.dispatch(updateFavourite(this.props.article.id));
  }
  render() {
    const { article } = this.props;
    return (
      <li className="cb-blog_listing_item">
        <div>
          <div className="cb-blog_listing_item_wrap">
            <button
              onClick={this.updateFavourite}
              className={`${this.props.favourites.length && this.props.favourites.indexOf(article.id) !== -1 ?
                'cb-blog_listing_item_fav cb-blog_listing_item_fav_on' :
                'cb-blog_listing_item_fav'}`}
              aria-label="Favourite this article."
            />
          </div>
          { article.image ? <a target="_blank" href={article.link}><img src={article.image} alt={article.title} /></a> : null }

          <p className="cb-blog_listing_item_date">Posted <strong>{article.date}</strong>, {article.year}</p>
          <h2 className="h3"><a target="_blank" href={article.link}>{article.title}</a></h2>
          <p className="h4">By {article.author}</p>
          <p>{article.description}</p>
        </div>
        <p className="cb-blog_listing_button">
          <a target="_blank" href={article.link} className="button">Read More</a>
        </p>
      </li>
    );
  }
}

ArticleBlockObj.propTypes = {
  article: PropTypes.object.isRequired,
};


const ArticleBlock = connect(state => ({
  favourites: state.articleFavourites,
}), dispatch => ({ dispatch }))(ArticleBlockObj);


class RelatedArticles extends React.Component {
  state = {
    showFavourites: false,
    filter: null,
    page: 1,
    name: '',
    selects: {
      84: 'Health Articles',
      25: 'Health Tips',
      32: 'Tools & Calculators',
      103: 'Apps',
    },
  };
  componentDidMount() {
    this.update();
    this.props.dispatch(getFavourites());
  }
  componentDidUpdate(prevProps) {
    if (this.props.pathway !== prevProps.pathway) {
      this.update();
    }
  }

  selectFilter = (e) => {
    this.setState({ filter: e.target.value }, () => {
      this.update();
    });
  }

  update = () => {
    this.props.dispatch(getArticles(
      this.props.pathway,
      this.state.filter,
      (this.state.showFavourites ? this.props.favourites : false),
      this.state.name,
      this.state.page,
    ));
  }

  render() {
    return (
      <div className="relatedarticles">
        <div className="header">
          <div className="row">
            <div className="col">
              <div className={`niceselect-wrapper ${this.state.filter ? '' : 'niceselect-default'}`}>
                <span className="niceselect-text">{this.state.filter ? this.state.selects[this.state.filter] : 'Filter by type' }</span>
                <select onChange={this.selectFilter} defaultValue={this.state.filter}>
                  <option value="">Please Select</option>
                  {Object.keys(this.state.selects).map(key => <option value={key} key={key}>{this.state.selects[key]}</option>)}
                </select>
              </div>
            </div>
            <div className="col">
              <input type="text" className="input-search" placeholder="Search by keyword" onChange={e => this.setState({ name: e.target.value, page: 1 })} />
              <a className="button" onClick={this.update}>Search</a>
            </div>
            <div className="col">
              <a
                className={`${!this.state.showFavourites ? 'fav on' : 'fav'}`}
                onClick={() => {
                this.setState({ showFavourites: !this.state.showFavourites }, () => {
                  this.update(null, !this.state.showFavourites);
                });
              }}
              >
                { !this.state.showFavourites ? 'Show favourites' : 'Hide Favourites' }
              </a>
            </div>
          </div>
        </div>

        <ul className="cb-blog_listing cb-blog_listing__activity">
          { this.props.articles.data && this.props.articles.data.map(article => <ArticleBlock key={`article-${article.id}`} article={article} />)}
        </ul>

        {this.props.articles.data ? <PaginationBar
          total={this.props.articles.last_page}
          currentPage={this.state.page}
          changePage={page => this.setState({ page }, () => { this.update(); })}
        /> : null }
      </div>
    );
  }
}

RelatedArticles.propTypes = {
  dispatch: PropTypes.func.isRequired,
  pathway: PropTypes.string.isRequired,
};

export default connect(state => ({
  articles: (state.articles ? state.articles : []),
  pathway: state.pathway,
  favourites: state.articleFavourites,
}), dispatch => ({ dispatch }))(RelatedArticles);



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Modules/RelatedArticles.jsx